export function checkExpiration(dataString) {
    if(!dataString){
        return false;
    }
    if(dataString==="never"){
        return true;
    }
    const data = new Date(dataString);    
    data.setHours(0, 0, 0, 0);
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    return data >= hoje;
}

function stringToColor(string) {
    let hash = 0;
    let i;
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    return color;
}

export function stringAvatar(name,size) {
    return {
        sx: {
            width: size,
            height: size,
            bgcolor: stringToColor(name),
        },
        children: `${name.split(' ')[0][0]}`,
    };
}

const COMMENT_ADMIN_UIDS = new Set([
    "RWVfVOmuO7XLb9ngBnLdoEdwzFu2",
    "65",
    "1",
]);

const COMMENT_ADMIN_PHOTO_URL = "/images/users/raul-ando.jpg";

export function getCommentAvatarProps(userUid, displayName, size = 40) {
    if (COMMENT_ADMIN_UIDS.has(userUid)) {
        return {
            src: COMMENT_ADMIN_PHOTO_URL,
            sx: {
                width: size,
                height: size,
            },
        };
    }

    return stringAvatar(displayName, size);
}

export function friendlyDate(data) {    
    var partes = data.split("-");       
    var ano = partes[0];
    var mes = partes[1];
    var dia = partes[2];
    var novaData = dia + "/" + mes + "/" + ano;
    return novaData;    
}

export function numberToBRL(numero) {
    const numeroFormatado = numero.toFixed(2);
    const partes = numeroFormatado.split('.');
    const parteInteiraFormatada = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'R$ ' + parteInteiraFormatada + ',' + partes[1];
}

export function numberToUSD(numero) {
    const numeroFormatado = numero.toFixed(2);
    const partes = numeroFormatado.split('.');
    const parteInteiraFormatada = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'US$ ' + parteInteiraFormatada + '.' + partes[1];
}

export function formatPersonName(name) {
    if (!name) {
        return "";
    }

    const capitalizeSegment = (segment) => {
        if (!segment) {
            return "";
        }

        const lower = segment.toLocaleLowerCase('pt-BR');
        return lower.charAt(0).toLocaleUpperCase('pt-BR') + lower.slice(1);
    };

    return name
        .trim()
        .split(/\s+/)
        .map((word) => word.split('-').map(capitalizeSegment).join('-'))
        .join(' ');
}
